/**
 * Chuỗi hiển thị của màn quản trị nhà cung cấp thiết bị, bộ tương thích và phần
 * "Tài khoản kết nối" trong chi tiết thiết bị.
 */
export const viNhaCungCap = {
  tieuDe: 'Nhà cung cấp thiết bị',
  moTa: 'Khai báo đơn vị cung cấp thiết bị và cấp tài khoản để hệ thống của họ (hoặc từng thiết bị) kết nối vào hệ thống nguồn.',

  huongDan: {
    tieuDe: 'Hai cách kết nối',
    gianTiep: 'Gián tiếp qua bộ tương thích',
    gianTiepMoTa:
      'Nhà cung cấp dựng một dịch vụ trung gian. Khai báo bộ tương thích bên dưới để cấp MỘT tài khoản cho cả hệ thống của nhà cung cấp.',
    trucTiep: 'Thiết bị kết nối trực tiếp',
    trucTiepMoTa:
      'Mỗi thiết bị tự kết nối MQTT (cụm loa: cổng 8883, bảng điện tử: cổng 8884) hoặc Websocket (wss, cổng 443). Cấp tài khoản cho từng thiết bị trong trang chi tiết thiết bị.',
    taiLieu: 'Tài liệu kỹ thuật gửi nhà cung cấp: docs/BAN-GIAO-KY-THUAT-THIET-BI.md',
  },

  ncc: {
    tieuDe: 'Danh sách nhà cung cấp',
    them: 'Thêm nhà cung cấp',
    sua: 'Sửa nhà cung cấp',
    ma: 'Mã nhà cung cấp',
    maGoiY: 'VD: VTC — chữ không dấu, số, ".", "_", "-"',
    ten: 'Tên nhà cung cấp',
    dauMoi: 'Đầu mối liên hệ',
    dauMoiGoiY: 'Họ tên, số điện thoại, email',
    soBtt: 'Bộ tương thích',
    soThietBi: 'Thiết bị',
    rong: 'Chưa có nhà cung cấp nào. Thêm nhà cung cấp trước khi khai báo thiết bị.',
    daTao: 'Đã thêm nhà cung cấp',
    daSua: 'Đã cập nhật nhà cung cấp',
  },

  btt: {
    tieuDe: 'Bộ tương thích (kết nối gián tiếp)',
    them: 'Khai báo bộ tương thích',
    sua: 'Sửa bộ tương thích',
    nhaCungCap: 'Nhà cung cấp',
    chonNhaCungCap: 'Chọn nhà cung cấp',
    urlGoc: 'URL gốc của bộ tương thích',
    urlGocGoiY: 'https://adapter.nhacungcap.vn',
    noiDat: 'Nơi đặt',
    noiDatGiaTri: {
      phia_nha_cung_cap: 'Phía nhà cung cấp',
      tren_he_thong_nguon: 'Trên hệ thống nguồn',
    } as Record<string, string>,
    dichVu: 'Dịch vụ hỗ trợ',
    goiVao: {
      tieuDe: 'Tài khoản gọi vào adapter (do nhà cung cấp cấp)',
      moTa: 'Tài khoản nhà cung cấp cấp cho hệ thống nguồn để lấy token khi gọi DV002/DV003/DV004/DV009 vào adapter của họ. Để trống tài khoản: hệ thống dùng token do chính hệ thống nguồn ký.',
      urlToken: 'Đường dẫn lấy token',
      urlTokenGoiY: '/oauth/token',
      taiKhoan: 'Tài khoản (Username)',
      matKhau: 'Mật khẩu (Password)',
      matKhauDaLuu: '•••••• đã lưu — để trống nếu không đổi',
      nangCao: 'Nâng cao — chỉ dùng khi adapter KHÔNG dùng khuôn {"Username", "Password"}',
      nangCaoCanhBao:
        'Đây là TÊN KHOÁ JSON, không phải giá trị. KHÔNG nhập tài khoản hay mật khẩu vào đây — adapter theo khuôn DV001 thì để trống cả ba ô.',
      truongTaiKhoan: 'Tên khoá JSON chứa tài khoản (mặc định: Username)',
      truongMatKhau: 'Tên khoá JSON chứa mật khẩu (mặc định: Password)',
      duongDanToken: 'Vị trí token trong phản hồi',
      duongDanTokenGoiY: 'Để trống = tự dò (NoiDung.Token, data.accessToken, access_token, token…)',
      thu: 'Thử lấy token',
      dangThu: 'Đang thử…',
      canLuuTruoc: 'Lưu trước rồi bấm "Thử lấy token" (thử bằng tài khoản đã lưu).',
      thuDat: 'Lấy token thành công: {token} — hết hạn {het} ({ms} ms).',
      thuLoi: 'Không lấy được token: {loi}',
      coTaiKhoan: 'Gọi vào adapter bằng tài khoản {tk}',
    },
    duongDan: {
      tieuDe: 'Đường dẫn dịch vụ của adapter',
      moTa: 'Khai đường dẫn adapter của nhà cung cấp mở ra cho từng dịch vụ: đường dẫn bắt đầu bằng "/" (nối sau URL gốc) hoặc URL đầy đủ. Để trống = đường dẫn mặc định.',
      khac: 'Dịch vụ khác và kiểm tra sức khoẻ',
      goiThu: 'Hệ thống sẽ gọi',
      mucDichVu: [
        ['DV002', 'DV002 — Gửi danh sách bản tin phát thanh', '/adapter/v1/phat'],
        ['DV003', 'DV003 — Yêu cầu phát bản tin khẩn cấp', '/adapter/v1/phat'],
        ['DV004', 'DV004 — Hủy lịch phát bản tin', '/adapter/v1/huy-phat'],
        ['DV009', 'DV009 — Thiết lập điều khiển cụm thu phát thanh', '/adapter/v1/dieu-khien'],
        ['DV010', 'DV010 — Gửi bản tin kèm lịch cho bảng tin điện tử (bắt buộc khai)', ''],
        ['DV011', 'DV011 — Phát khẩn cấp trên bảng tin điện tử (bắt buộc khai)', ''],
        ['DV012', 'DV012 — Hủy lịch phát bảng tin điện tử (bắt buộc khai)', ''],
        ['DV017', 'DV017 — Điều khiển bảng tin điện tử (bắt buộc khai)', ''],
      ] as [string, string, string][],
      mucKhac: [
        ['truy_van_trang_thai', 'Truy vấn trạng thái tức thời', '/adapter/v1/trang-thai'],
        ['dong_bo_lich_phat', 'Đồng bộ lịch phát', '/adapter/v1/dong-bo-lich-phat'],
        ['cap_nhat_phan_mem', 'Cập nhật phần mềm', '/adapter/v1/cap-nhat-phan-mem'],
        ['health_live', 'Kiểm tra sống (GET)', '/health/live'],
        ['health_ready', 'Kiểm tra sẵn sàng (GET)', '/health/ready'],
      ] as [string, string, string][],
      soKhaiRieng: '{so} dịch vụ khai đường dẫn riêng',
    },
    dichVuGoiY: 'VD: DV005, DV006, DV007, DV008',
    dsIp: 'IP được phép',
    dsIpGoiY: 'VD: 203.0.113.10, 10.0.0.0/24',
    tanSuat: 'Giới hạn lời gọi/phút',
    camKet: 'Thời gian phản hồi cam kết (ms)',
    tenDangNhap: 'Tên đăng nhập',
    kiemThu: 'Kiểm thử tuân thủ',
    kiemThuGiaTri: { chua_kiem_thu: 'Chưa kiểm thử', dat: 'Đạt', khong_dat: 'Không đạt' } as Record<
      string,
      string
    >,
    serviceDvNcc: 'Service gửi lệnh',
    serviceChuaCo: 'Chưa có — gửi trực tiếp tới adapter',
    serviceThuHoi: 'Đã thu hồi',
    serviceCong: 'cổng {cong}',
    vanHanhGiaTri: {
      dang_chay: 'Đang chạy',
      dang_trien_khai: 'Đang triển khai',
      tam_dung: 'Tạm dừng',
      loi: 'Lỗi',
      cau_dao_mo: 'Cầu dao mở',
    } as Record<string, string>,
    capLai: 'Cấp lại mật khẩu',
    chayKiemThu: 'Chạy kiểm thử tuân thủ',
    tuanThu: {
      tieuDe: 'Kiểm thử tuân thủ — {ma}',
      moTa: 'Bộ kiểm thử gọi adapter bằng mã thiết bị giả (không phát ra loa thật). Chỉ khi mọi ca bắt buộc đạt, hệ thống nguồn mới cho gửi DV002/DV003/DV004/DV009 qua adapter này.',
      dangChay: 'Đang chạy bộ kiểm thử… (có thể mất tới vài chục giây)',
      loi: 'Không chạy được bộ kiểm thử: {loi}',
      dat: 'ĐẠT',
      khongDat: 'KHÔNG ĐẠT',
      tomTat: '{dat}/{tong} ca đạt, {sai} ca không đạt.',
      ca: 'Ca',
      noiDung: 'Nội dung — mong đợi',
      ketQua: 'Kết quả',
      thucTe: 'Thực tế nhận được',
      batBuoc: 'bắt buộc',
      giaTri: { dat: 'Đạt', khong_dat: 'Không đạt', bo_qua: 'Bỏ qua' } as Record<string, string>,
    },
    moKhoa: 'Mở khoá',
    biKhoa: 'Bị khoá đến',
    rong: 'Chưa có bộ tương thích nào.',
    xoa: 'Xoá',
    xoaChiKhiNgung: 'Chỉ xoá được bộ tương thích đã Ngừng hoạt động',
    xacNhanXoaTieuDe: 'Xoá bộ tương thích',
    xacNhanXoa:
      'Xoá hẳn bộ tương thích {ten} của {ncc}. Tài khoản DV001 và mọi token đã cấp bị thu hồi ngay; thao tác không hoàn tác được. Chỉ xoá được khi không còn thiết bị nào gắn với bộ tương thích này.',
    daXoa: 'Đã xoá bộ tương thích.',
    daXoaGoService:
      'Đã xoá bộ tương thích cuối cùng của nhà cung cấp — bản ghi service gửi lệnh đã gỡ; chạy lại dv-ncc.sh trên máy chủ để dừng container.',
    canNccTruoc: 'Thêm nhà cung cấp trước khi khai báo bộ tương thích.',
    xacNhanCapLaiTieuDe: 'Cấp lại mật khẩu bộ tương thích',
    xacNhanCapLai:
      'Mật khẩu hiện tại của {ten} hết hiệu lực ngay và mọi token đã cấp bị thu hồi. Hệ thống của nhà cung cấp mất kết nối cho tới khi cập nhật mật khẩu mới.',
    daMoKhoa: 'Đã mở khoá tài khoản',
    daSua: 'Đã cập nhật bộ tương thích',
  },

  chung: {
    trangThai: 'Trạng thái',
    trangThaiGiaTri: { active: 'Hoạt động', inactive: 'Ngừng hoạt động' } as Record<string, string>,
    thaoTac: 'Thao tác',
    luu: 'Lưu',
    huy: 'Huỷ',
    dong: 'Đóng',
    ngung: 'Ngừng',
    kichHoat: 'Kích hoạt',
    dangGui: 'Đang gửi…',
    thatBai: 'Thao tác thất bại',
    batBuoc: 'bắt buộc',
  },

  /* Hộp thông tin đăng nhập — chỉ hiện một lần. */
  taiKhoan: {
    tieuDe: 'Thông tin đăng nhập kết nối',
    canhBao:
      'Mật khẩu chỉ hiển thị MỘT LẦN. Sao chép và gửi cho đơn vị cung cấp qua kênh an toàn; đóng hộp này sẽ không xem lại được.',
    diaChi: 'Địa chỉ xác thực (DV001)',
    tenDangNhap: 'Tên đăng nhập (Username)',
    matKhau: 'Mật khẩu (Password)',
    saoChep: 'Sao chép',
    daSaoChep: 'Đã sao chép',
    saoChepTatCa: 'Sao chép tất cả',
    daLuu: 'Tôi đã lưu thông tin đăng nhập',
  },

  /* Phần "Tài khoản kết nối" trong chi tiết thiết bị. */
  thietBi: {
    tieuDe: 'Tài khoản kết nối',
    gianTiep:
      'Thiết bị kết nối gián tiếp — xác thực qua tài khoản bộ tương thích của nhà cung cấp, không cấp tài khoản riêng.',
    chuaCo:
      'Chưa có tài khoản. Thiết bị tự kích hoạt: gọi DV001 với Username = Password = mã thiết bị (token có hạn 5 phút), rồi DV018 để nhận mật khẩu. Hoặc tỉnh bấm "Cấp tài khoản" để cấp mật khẩu thủ công.',
    kichHoatLai: 'Cho phép kích hoạt lại',
    kichHoatLaiTieuDe: 'Cho phép thiết bị kích hoạt lại',
    kichHoatLaiMoTa:
      'Xoá tài khoản của thiết bị {ma}, thu hồi {so} token và quyền topic. Thiết bị mất kết nối cho tới khi tự kích hoạt lại bằng mã thiết bị (DV001 lần đầu, rồi DV018). Dùng khi thiết bị mất mật khẩu.',
    daKichHoatLai:
      'Đã cho phép kích hoạt lại. Thiết bị cần gọi DV001 bằng mã thiết bị rồi DV018 trong 5 phút.',
    tenDangNhap: 'Tên đăng nhập',
    thoiDiemCap: 'Cấp lúc',
    daThuHoi: 'Đã thu hồi lúc',
    biKhoa: 'Bị khoá đến',
    soToken: 'Token còn hiệu lực',
    cap: 'Cấp tài khoản',
    capLai: 'Cấp lại mật khẩu',
    thuHoi: 'Thu hồi kết nối',
    moKhoa: 'Mở khoá',
    xacNhanCapLaiTieuDe: 'Cấp lại mật khẩu thiết bị',
    xacNhanCapLai:
      'Mật khẩu hiện tại của thiết bị {ma} hết hiệu lực ngay, {so} token đang dùng bị thu hồi. Thiết bị mất kết nối cho tới khi nạp mật khẩu mới.',
    thuHoiTieuDe: 'Thu hồi kết nối thiết bị',
    thuHoiMoTa:
      'Thu hồi {so} token, khoá tài khoản và xoá quyền topic của thiết bị {ma}. Lời gọi REST và Websocket bị chặn ngay; phiên MQTT đang mở mất quyền gửi/nhận trong tối đa khoảng 90 giây. Muốn dùng lại phải "Cấp lại mật khẩu".',
    lyDo: 'Lý do thu hồi',
    lyDoGoiY: 'Tối thiểu 5 ký tự, ghi vào nhật ký',
    daThuHoiXong: 'Đã thu hồi kết nối thiết bị',
    daMoKhoa: 'Đã mở khoá tài khoản',
  },
};
